module.exports = __webpack_public_path__ + "img/客服02.9ba48f5d.svg";